goog.provide('el8.util.consts');

goog.require('el8.service.tz');

el8.util.consts = (function() {

    var that = {
        DEFAULT_VISIT_NOTE_TEMPLATE: 'twoCol.complex2',  // will be default for any user that doesn't have a default already set
        DEFAULT_NONVISITNOTE_TYPE: 'nonvisit',
        CHART_FEED_PAGESIZE: 15,
        REPORT_FEED_PAGESIZE: 15,
        REF_PANEL_WIDTH: 390,
        MAX_CARD_SUMMARY_LENGTH: 50,
        DIALOG_BORDER: 10,
        LARGE_FIELD_LENGTH: 200,
        DEFAULT_FIELD_HEIGHT: 16,
        LARGE_FIELD_HEIGHT: 19,
        XL_FIELD_HEIGHT: 32,
        SPELLCHECK: true,

        DELETE_CONFIRM_DIALOG_WIDTH: 520,

        DEFAULT_DURATION: 500,
        QUICK_ANIMATION: 300,
        RESIZE_RATE: 200, // debounce input: ignore resize events more frequent than this (ms),
        MOUSEMOVE_RATE: 100, // debounce input: ignore mousemove events more frequent than this (ms),
        DOUBLE_CLICK_RATE: 800, // debounce input: use when double clicks are bad but we can't form.disable()/enable()
        FADE_RATE: 500,

        MAX_MED_LENGTH: 100, // SS' limit for med names we eRx is 105

        MOBILE_WIDTH: 480, // doesn't include iPads

        MIN_DATE: el8.service.tz.newTzDate(1900, 0, 1),   // 1/1/1900

        SCHEDULER_BLOCK_COLOR: '#eee',

        // Currenly just a string property on an apptType. Sampled from our new icon colors
        // with added with .3+ alpha and some closely related colors removed.
        SCHEDULER_COLORS: [
            ['Pink', '#FDE4EF'],
            ['Orange', '#FFE7D0'],
            ['Green', '#D4EDD1'],
            ['Olive', '#EBEBD2'], // from tableau light
            ['Teal', '#DDF2F6'],
            ['Brown', '#E9D9D6'], // .3 #DDC5C1, lighter: E9D9D6
            ['Deep Yellow', '#FBEA7C'],
            ['Deep Orange', '#FFC87B'],
            ['Deep Blue', '#B5D9FF'],
            ['Deep Purple', '#E3C0FF']
        ],

        SCHEDULER_DURATIONS: [
            5,
            10,
            15,
            20,
            25,
            30,
            35,
            40,
            45,
            50,
            55,
            60,
            65,
            70,
            75,
            80,
            90,
            100,
            110,
            120,
            150,
            180,
            240
        ],

        MAX_VISIT_SUMMARY_IMAGES: 3,

        DEFAULT_ERROR_MSG: 'An error has occurred. Please refresh the page. If this persists, ' +
                'contact Support using the "I need help" menu above.',

        PASSPORT_DEFAULT_ERROR_MSG: "Sorry, there was an error! Please refresh the page.",
        ACCESS_DEFAULT_ERROR_MSG: "Sorry, there was an error! Please refresh the page.",
        DEFAULT_CONFLICT_ERROR_MSG: "A change was made to this content. Please refresh the page and try again.",

        // Layout
        DIVIDER_WIDTH: 65,
        PANE_CUSHION: 5,
        MAX_LHS_WIDTH: 385,
        MIN_LHS_WIDTH: 250,
        FOUR_P_WIDTH: 300,
        LHS_SPLIT: 0.3,
        MIN_CHART_FEED_WIDTH: 570,
        THREE_PANE_AVAIL_WIDTH: 1435,
        WRITE_SEE_COLLAPSE_WIDTH: 730,
        REPORTS_DIALOG_WIDTH: 570,

        NUM_LOOKUP: {
            'one': 1,
            'two': 2,
            'three': 3,
            'four': 4,
            'five': 5,
            'six': 6,
            'seven': 7,
            'eight': 8,
            'nine': 9,
            'ten': 10,
            'eleven': 11,
            'twelve': 12,
            'thirteen': 13,
            'fourteen': 14,
            'fifteen': 15,
            'sixteen': 16,
            'seventeen': 17,
            'eighteen': 18,
            'nineteen': 19,
            'twenty': 20
        },

        AUTOCOMPLETE_OPTS : function() {
            return {
                minChars : 1,
                mustMatch : false,
                matchContains: true,
                max : 300,
                scroll : true,
                selectFirst : false
            };
        },

        HISTORY_ITEM_TYPES: [
            'past',
            'social',
            'family',
            'habits',
            'diet',
            'exercise',
            'legal',
            'consultation',
            'immunization',
            'maintenance',
            'surgical',
            'cognitive',
            'functional',
            'psychological'
        ],

        REPORT_TYPES_PER_ROW: 8,

        ORDER_TYPES: [
            'lab',
            'imaging',
            'referral',
            'cardiac',
            'pulmonary',
            'sleep'
        ],
        IMMUNIZATION_REGISTRY_QUANTITY_UNITS: [  // RM-15356 UCUM values
            "dL",
            "g",
            "kg",
            "kL",
            "L",
            "mg",
            "mL",
            "ug",
            "uL",
            "tab",
        ],
        SURESCRIPTS_ALLOWED_QUANTITY_UNITS: [
            'applicator',
            'blister',
            'caplet',
            'capsule',
            'each',
            'film',
            'gram',
            'gum',
            'implant',
            'insert',
            'kit',
            'lancet',
            'lozenge',
            'milliliter',
            'needle',
            'packet',
            'pad',
            'patch',
            'pen needle',
            'ring',
            'sponge',
            'stick',
            'strip',
            'suppository',
            'swab',
            'tablet',
            'troche',
            'unspecified',
            'wafer'
        ],
        MED_ORDER_QUANTITY_DISPLAY_UNITS_EPCS: [
            'ampule',
            'applicator',
            'applicatorful',
            'bag',
            'bar',
            'bead',
            'blister',
            'block',
            'bolus',
            'bottle',
            'box',
            'can',
            'canister',
            'caplet',
            'capsule',
            'carton',
            'cartridge',
            'case',
            'cassette',
            'container',
            'cylinder',
            'disk',
            'dose pack',
            'dual pack',
            'each',
            'film',
            'fluid ounce',
            'gallon',
            'gram',
            'gum',
            'implant',
            'inhalation',
            'inhaler',
            'inhaler refill',
            'insert',
            'intravenous bag',
            'kilogram',
            'kit',
            'liter',
            'lozenge',
            'metric drop',
            'milligram',
            'milliliter',
            'millimeter',
            'nebule',
            'needle free injection',
            'ocular system',
            'ounce',
            'package',
            'packet',
            'pad',
            'paper',
            'patch',
            'pint',
            'pouch',
            'pound',
            'pre-filled pen syringe',
            'puff',
            'quart',
            'ring',
            'sachet',
            'scoopful',
            'sponge',
            'spray',
            'stick',
            'strip',
            'suppository',
            'swab',
            'syringe',
            'tablespoon',
            'tablet',
            'tabminder',
            'tampon',
            'teaspoon',
            'tray',
            'troche',
            'tube',
            'vial',
            'wafer'
        ],

        MED_ORDER_QUANTITY_DISPLAY_UNITS: [
            'amp',
            'ampule',
            'applicator',
            'applicatorful',
            'bag',
            'bar',
            'bead',
            'blister',
            'block',
            'bolus',
            'bottle',
            'box',
            'btl',
            'can',
            'canister',
            'cap',
            'caplet',
            'capsule',
            'carton',
            'cartridge',
            'case',
            'cassette',
            'container',
            'cylinder',
            'disk',
            'dose pack',
            'dual pack',
            'each',
            'film',
            'fl oz',
            'fluid ounce',
            'g',
            'gal',
            'gallon',
            'gram',
            'gum',
            'implant',
            'inhalation',
            'inhaler',
            'inhaler refill',
            'insert',
            'intravenous bag',
            'kg',
            'kilogram',
            'kit',
            'L',
            'lb',
            'liter',
            'lozenge',
            'metric drop',
            'mg',
            'milligram',
            'milliliter',
            'millimeter',
            'mL',
            'mm',
            'nebule',
            'needle free injection',
            'ocular system',
            'ounce',
            'oz',
            'package',
            'packet',
            'pad',
            'paper',
            'patch',
            'pint',
            'pkg',
            'pouch',
            'pound',
            'pre-filled pen syringe',
            'pt',
            'puff',
            'qt',
            'quart',
            'ring',
            'sachet',
            'scoopful',
            'sponge',
            'spray',
            'stick',
            'strip',
            'suppository',
            'swab',
            'syringe',
            'tab',
            'tablespoon',
            'tablet',
            'tabminder',
            'tampon',
            'tbsp',
            'teaspoon',
            'tray',
            'troche',
            'tsp',
            'tube',
            'unspecified',
            'vial',
            'wafer'
        ],

        PROBLEM_STATUS_CHOICES : [
            'Active',
            'Controlled',
            'Resolved'
        ],

        ALLERGY_STATUS_CHOICES : [
            'Active',
            'Inactive'
        ],

        ALLERGY_SEVERITY_SNOMEDS : [
          ['', '--'],
          ['255604002', 'mild'],
          ['6736007', 'moderate'],
          ['24484000', 'severe']
        ],

        SMOKING_STATUS_TYPES : [
            [4, 'Never smoker'],
            [9, 'Unknown if ever smoked'],
            [3, 'Former smoker'],
            [1, 'Current every day smoker'],
            [2, 'Current some day smoker'],
            [5, 'Smoker, current status unknown'],
            [6, 'Light tobacco smoker'],
            [7, 'Heavy tobacco smoker']
        ],

        CDS_DRUG_DRUG_ALERT_LEVELS : [
            [1, 'Major alerts only'],
            [2, 'Major and moderate alerts only'],
            [3, 'All alerts']
        ],

        CDS_DRUG_ALLERGY_ALERT_LEVELS : [
            [1, 'On'],
            [2, 'Off']
        ],

        LETTER_EMAIL_NOTIFICATIONS : [
            ['none', 'No one'],
            ['patient', 'Patients only'],
            ['provider', 'Providers only'],
            ['all', 'Everyone']
        ],

        VACCINE_METHODS : [
            'Oral (PO)',
            'Intranasal (NS)',
            'Subcutaneous (SC)',
            'Intramuscular (IM)'
        ],

        // These two should match with the code maps in the HL7 processors in the BE
        // elation/patients/immunization_hl7_services.py:594
        VACCINE_INTRAMUSCULAR_SITES : [
            'R Thigh',
            'L Thigh',
            'R Tricep (R tric)',
            'L Tricep (L tric)',
            'R Deltoid (RD)',
            'L Deltoid (LD)'
        ],

        VACCINE_SUBCUTANEOUS_SITES : [
            'R Anterolateral Thigh',
            'L Anterolateral Thigh',
            'R Upper Arm',
            'L Upper Arm'
        ],

        // These two match the code maps defined by the HL7 value set used by IronBridge
        // VACCINATION_SITES defined on the BE in elation/api/services_ironbridge.py:179
        VACCINATION_SITES_INTRAMUSCULAR : [
            'Left Arm',
            'Left Deltoid',
            'Left Gluteus Medius',
            'Left Lower Forearm',
            'Left Thigh',
            'Left Vastus Lateralis',
            'Right Arm',
            'Right Deltoid',
            'Right Gluteus Medius',
            'Right Lower Forearm',
            'Right Thigh',
            'Right Vastus Lateralis',
        ],

        VACCINATION_SITES_SUBCUTANEOUS : [
            'Left Thigh',
            'Right Thigh',
            'Left Arm',
            'Right Arm',
        ],

        PATIENT_TYPE_MAX_AGE_MAP : {
            'infant' : 5,
            'children' : 17
        },

        CONTACT_CREDENTIALS : [
            'MD', 'DO', 'PA', 'PA-C', 'NP', 'FNP', 'PNP', 'ANP', 'GNP',
            'APNP', 'RN', 'LPN', 'NP', 'CNS', 'CNM', 'CRNA', 'PT', 'DDS',
            'ND', 'DNP'
        ],

        // types for letters
        CONSULTANT_LETTER : 'provider',
        PATIENT_LETTER: 'patient',
        REFERRAL_LETTER: 'referral',

        /* These get used in Letters as model classes
           when attaching the refpanel/demog */
        REFPANEL_PSEUDO_CLASS : 'RefPanel',
        DEMOG_PSEUDO_CLASS : 'PatientDemog',

        RECEIPT_BODY_ATTACHMENT: 'LetterContent',

        EL8_HI_FAX_PAGES : 20, // we'll force clip the fax at this point
        EL8_DOWNLOAD_ONLY_PAGES: 50, // we'll consider letters to be chart exports (no printing) at this point

        MEDICAL_GROUP_TYPE : 'medical_group',
        PHYSICIAN_TYPE : 'physician',

        // Note: these are the "external" statuses. See BILL_STATUS_EXTERNAL_CHOICES
        BILLING_STATUS: {
            'Unbilled': 0,
            'Billed': 1,
            'UnresolvedError': 2,
            'ResolvedError': 3
        },

        BILL_COMPLETENESS_ALERT_PREFERENCES: {
            'none': 1,
            'soft': 2,
            'hard': 3
        },

        REGULAR_FEEDBACK_TYPE: 'regular',
        SUGGESTION_FEEDBACK_TYPE: 'suggestion',
        URGENT_FEEDBACK_TYPE: 'urgent',

        // use this with a "less than" check (i.e., 21+ is not pediatric)
        PEDIATRIC_AGE_LIMIT: 21,

        DOC_TAG_CODE_TYPES: ['CPT', 'CPTII', 'HCPCS', 'ICD9', 'ICD10', 'LOINC', 'SNOMED'],

        SHARED_BY_FACET_VALUE: 'Collaborative View', // used to be'Shared By',
        DOCTYPE_FACET_VALUE: 'Type',
        VISIT_NOTE_TYPE_FACET_VALUE: 'NT', // chrono filter by Visit Note Type

        IMO_VISIT_SECTIONS: ['assessment', 'assessplan'],

        ADDITIONAL_VITALS: ['bodyfat', 'dlm', 'bfm', 'wc', 'ketone', 'fio2', 'smm'],

        // USPS https://en.wikipedia.org/wiki/List_of_U.S._state_abbreviations
        STATES: ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL',
                 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME',
                 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH',
                 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI',
                 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI',
                 'WY', 'AS', 'GU', 'MP', 'PR', 'VI'],

        IMPLANTABLE_DEVICE_STATUS_CHOICES : [
            'Active',
            'Inactive'
        ],

        TAXONOMY_PRESCRIPTION_FORM_TYPE_NAME_MAP: {
            'prescription': 'unified rx form',
            'otc': 'OTC form',
            'controlled': 'controlled substance form',
            'samples': 'samples form'
        },

        TAXONOMY_REF_BOARD_SECTION_HEADER_ID_NAME_MAP: {
            'perm-rx-meds-summary': 'permanent Rx meds in clinical profile',
            'perm-otc-meds-summary': 'permanent OTC meds in clinical profile',
            'recent-meds-summary': 'scripts since last 6 visits'
        },

        TAXONOMY_PATIENT_CHART_CREATION_SOURCE_MAP: {
            'doc-mgr': 'patient search mindreader - file document from queue',
            'top-bar': 'patient search mindreader - find patient',
            'new-chart': 'new chart',
            'appt': 'patient search mindreader - create appointment',
            'practice-home': 'patient search mindreader - find patient'
        },
        NTE_PSEUDO_AOEQUESTION_CODE: "__TESTNOTE__", // See elation.labs.services.laborder_hl7_services
        QUEST_FROZEN_TEMP_CODES: ["F", "FZ"],
        QUEST_ROOM_OR_FRIDGE_TEMP_CODES: ["A", "R", "RF", "RT"],

        APP_STATUS_OK: 1,
        APP_STATUS_DOWN: 2,
        APP_STATUS_RECOVERED: 3,
        APP_STATUS_WARNING: 4,
        APP_STATUS_PARTIAL_DOWN: 5,

        CHECK_PMP_HEADER_ID_NAME_MAP: {
            'meds-hx-menu': 'Med Hx dropdown',
            'meds-hx-content': 'Med Hx dialog',
            'perm-rx-meds-summary': 'Permanent Rx Meds'
        }
    };

    that.MED_ORDER_QUANTITY_UNITS_LOWERCASE = that.MED_ORDER_QUANTITY_DISPLAY_UNITS.map(function(unit) {
        return unit.toLowerCase();
    });

    return that;

})();

/**
 * This is a parallel to the AVAILABLE_REPORT_TYPES dict the server sends us.
 * That list is keyed on a document_sub_type (which we pretend is a reportType id).
 * This list is keyed on the lowercase version fo the report_type_label, which
 * is what we call the report_type in Reports and also what we key our report feeds on.
 */
el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY = {};
for (var typeId in el8Globals.AVAILABLE_REPORT_TYPES) {
    if (el8Globals.AVAILABLE_REPORT_TYPES.hasOwnProperty(typeId)) {
        var typeDetails = el8Globals.AVAILABLE_REPORT_TYPES[typeId];
        var key = typeDetails.report_type_label.toLowerCase();
        el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[key] = $.extend(typeDetails, {
            id: parseInt(typeId, 10)
        });
    }
}
